import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import classNames from "classnames";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";

const Button: FC<Props> = ({
  className = "",
  text,
  onClick,
  handleError = () => {},
  disabled = false,
  bgColor,
}) => {
  return (
    <div
      onClick={() => {
        if (disabled) {
          handleError();
          return;
        }
        onClick();
      }}
      style={{ background: bgColor }}
      className={classNames(
        styles.button,
        disabled && styles.disabled,
        className,
      )}
    >
      {text}
    </div>
  );
};

export default Button;
